import { createServerOnlyFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";
import { resolveExistingViewerRef } from "@/lib/core/auth";
import { getAuth } from "@/lib/core/auth-protocol.server.ts";
import { getKitsActionRuntime } from "@/lib/core/kits-actions.server.ts";
import { createApprovalHandler } from "./approval-handler.server.ts";

const handler = createApprovalHandler({
    async resolveViewer() {
        const viewer = await resolveExistingViewerRef();
        if (viewer?.isAuthenticated !== true) return null;
        const session = await (
            await getAuth()
        ).api.getSession({ headers: getRequestHeaders() });
        return session
            ? { ...viewer, sessionBinding: session.session.id }
            : null;
    },
    getRuntime: getKitsActionRuntime,
    now: () => new Date().toISOString(),
});
const handle = createServerOnlyFn(
    ({
        request,
        params,
    }: {
        request: Request;
        params: { approvalId: string };
    }) => handler(request, params.approvalId),
);
export const kitsApprovalRoute = {
    server: { handlers: { GET: handle, POST: handle } },
};
